<template>
  <div style="display: inline-block">
    <el-button @click="removeOrderById">删除</el-button>
  </div>
</template>

<script>
import { deleteOrderById } from '@/api/order/order'

export default {
  name: "deleteOrder",
  props: ['orderId', 'orderType'],
  data() {
    return {

    }
  },
  methods: {
    removeOrderById() {
      this.$confirm('是否删除,此操作不可逆?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteOrderById(this.orderId, this.orderType).then(res => {
          if (res.code === '0') {
            this.$message.success('删除成功');
            this.$emit('change', '')
          }
        })
      }).catch(() => {});

    }
  }
}
</script>

<style scoped>

</style>
